import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ChartBarIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/chart-bar"><g id="Icon"><path d="M18.6 2.3999C17.6059 2.3999 16.8 3.20579 16.8 4.1999V19.7999C16.8 20.794 17.6059 21.5999 18.6 21.5999H19.8C20.7941 21.5999 21.6 20.794 21.6 19.7999V4.1999C21.6 3.20579 20.7941 2.3999 19.8 2.3999H18.6Z" fill="currentColor" /><path d="M11.4 7.1999C10.4059 7.1999 9.60003 8.00579 9.60003 8.9999V19.7999C9.60003 20.794 10.4059 21.5999 11.4 21.5999H12.6C13.5941 21.5999 14.4 20.794 14.4 19.7999V8.9999C14.4 8.00579 13.5941 7.1999 12.6 7.1999H11.4Z" fill="currentColor" /><path d="M4.20002 11.9999C3.20591 11.9999 2.40002 12.8058 2.40002 13.7999V19.7999C2.40002 20.794 3.20591 21.5999 4.20002 21.5999H5.40002C6.39414 21.5999 7.20003 20.794 7.20003 19.7999V13.7999C7.20003 12.8058 6.39414 11.9999 5.40002 11.9999H4.20002Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ChartBarIcon;